module.exports = __webpack_public_path__ + "static/img/5.4619a66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/5.png
// module id = FMvX
// module chunks = 0